import { V2Axios, V1Axios } from 'src/utils/server';

export const CurriculumApi = {
  async getRegions() {
    try {
      const response = await V2Axios.get(`/admin/region`);
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async createRegion(body) {
    try {
      const response = await V2Axios.post(`/admin/region`, body);
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async updateCurriculum(body) {
    try {
      const response = await V2Axios.patch(`/curriculum/curriculum`, body);
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async createCurriculum(body) {
    try {
      const response = await V2Axios.post(`/curriculum/curriculum`, body);
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async getCurriculum(regionId) {
    try {
      const response = await V2Axios.get(`/curriculum/curriculum`, {
        params: {
          regionId,
        },
      });
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async getCurriculumSubdivision(body) {
    try {
      const response = await V2Axios.get(`/curriculum/curriculum/subdivision`, {
        params: body,
      });

      return response.data;
    } catch (error) {
      return false;
    }
  },
  async updateCurriculumSubdivision(body) {
    try {
      const response = await V2Axios.patch(
        `/curriculum/curriculum/subdivision`,
        body
      );
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async createCurriculumSubdivision(body) {
    try {
      const response = await V2Axios.post(
        `/curriculum/curriculum/subdivision`,
        body
      );
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async appendToCurriculum(body) {
    try {
      const response = await V1Axios.post(`/student-attach-curriculum`, body);
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async getSubjects(body) {
    try {
      const response = await V1Axios.get(`/subjects-options`, body);
      return response.data;
    } catch (error) {
      return false;
    }
  },
  async getLessonProgress(studentId) {
    try {
      const response = await V2Axios.get(`lessons/lesson-resources/`, {
        params: {
          studentId,
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
